module.exports = __webpack_public_path__ + "frontend/images/homepage/slider/card-3@2.jpg?fd090b254f7bb06995a547f0c3ef528e";